import { useState } from "react";
import { useMutation } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { syncPublishersToLegalDeposits } from "../api/adminService";
export var usePublishersSync = function () {
    var ky = useOkapiKy();
    var _a = useState(false), successModalOpen = _a[0], setSuccessModalOpen = _a[1];
    var _b = useState(false), errorModalOpen = _b[0], setErrorModalOpen = _b[1];
    var _c = useState(false), confirmModalOpen = _c[0], setConfirmModalOpen = _c[1];
    var _d = useMutation({
        mutationFn: function () { return syncPublishersToLegalDeposits(ky); },
        onSuccess: function () {
            setSuccessModalOpen(true);
        },
        onError: function (error) {
            console.error("Error syncing publishers to legal deposits:", error);
            setErrorModalOpen(true);
        },
    }), mutate = _d.mutate, isLoading = _d.isLoading, data = _d.data;
    var requestSync = function () {
        setConfirmModalOpen(true);
    };
    var confirmSync = function () {
        setConfirmModalOpen(false);
        mutate();
    };
    var cancelSync = function () {
        setConfirmModalOpen(false);
    };
    return {
        requestSync: requestSync,
        confirmSync: confirmSync,
        cancelSync: cancelSync,
        isLoading: isLoading,
        data: data,
        successModalOpen: successModalOpen,
        setSuccessModalOpen: setSuccessModalOpen,
        errorModalOpen: errorModalOpen,
        setErrorModalOpen: setErrorModalOpen,
        confirmModalOpen: confirmModalOpen,
    };
};
